import { Injectable } from '@angular/core';
import { Department, DepartmentAddressInfo, DepartmentSocialLinks } from '../../domain/models/department.model';
import { DepartmentAdminDto } from '../dtos/department-admin.dto';

@Injectable()
export class DepartmentAdminMapper {
  public toDepartment(dto: DepartmentAdminDto): Department {
    return {
      id: dto.Id,
      name: dto.Name,
      responsibleEmail: dto.ResponsibleEmail,
      timeZone: dto.TimeZone,
      isActive: dto.IsActive,
      createdAtUtc: dto.CreatedAtUtc,
      email: dto.Email,
      website: dto.Website,
      logoUrl: dto.LogoUrl,
      addressInfo: this.toAddressInfo(dto.AddressInfo),
      socialLinks: this.toSocialLinks(dto.SocialLinks),
      externalId: dto.ExternalId,
    };
  }

  private toAddressInfo(dto: DepartmentAdminDto['AddressInfo']): DepartmentAddressInfo | null {
    if (!dto) return null;
    return {
      phone: dto.phone ?? null,
      streetAddress1: dto.street_address_1 ?? null,
      streetAddress2: dto.street_address_2 ?? null,
      zipCode: dto.zip_code ?? null,
      city: dto.city ?? null,
      state: dto.state ?? null,
    };
  }

  private toSocialLinks(dto: DepartmentAdminDto['SocialLinks']): DepartmentSocialLinks | null {
    if (!dto) return null;
    const entries = Object.entries(dto).filter(
      (entry): entry is [string, string] => typeof entry[1] === 'string' && entry[1].trim().length > 0,
    );
    return entries.length ? Object.fromEntries(entries) : null;
  }
}
